export default __webpack_public_path__ + "static/besanladdoo-daef511b606884ef76639ff6d5f81aa2.png";